import React, { useState, useEffect } from 'react';
import { Tabs, Tooltip } from 'antd';
import NotesTab from './NotesTab';
import IncidentLogTab from './IncidentLogTab';
import LinkedDocsTab from './LinkedDocsTab';

const { TabPane } = Tabs;

const IncidentDocumentationTab = ({ incidentId }) => {
  const [activeSubTab, setActiveSubTab] = useState('logs');

  // Ensure the tab is set to logs when component mounts
  useEffect(() => {
    setActiveSubTab('logs');
  }, [incidentId]);

  const handleSubTabChange = (key) => {
    setActiveSubTab(key);
    // Navigation logging removed - not forensically relevant
  };

  return (
    <div className="incident-documentation-container">
      <Tabs
        key={`docs-tabs-${incidentId}`}
        activeKey={activeSubTab}
        onChange={handleSubTabChange}
        defaultActiveKey="logs"
        type="card"
        size="small"
        className="documentation-sub-tabs"
        style={{
          '--ant-tabs-card-active-color': '#39325b',
          '--ant-tabs-card-hover-color': '#39325b',
        }}
        tabBarStyle={{
          backgroundColor: '#fafafa',
          borderBottom: '1px solid #f0f0f0',
          margin: 0,
          paddingLeft: '16px'
        }}
        tabBarGutter={8}
      >
        <TabPane 
          tab={
            <Tooltip title="Activity Log: View chronological audit trail of all incident actions, updates, and system changes. This is an immutable record for compliance and review purposes.">
              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span>📜</span>
                <span>Activity Log</span>
              </span>
            </Tooltip>
          } 
          key="logs"
        >
          <div style={{ padding: '16px 0' }}>
            <IncidentLogTab incidentId={incidentId} />
          </div>
        </TabPane>
        
        <TabPane 
          tab={
            <Tooltip title="Notes and Documentation: Create, edit and manage text notes, formal documentation, and written records related to the incident. Use rich text formatting for professional reports.">
              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span>📝</span>
                <span>Notes and Documentation</span>
              </span>
            </Tooltip>
          } 
          key="notes"
        >
          <div style={{ padding: '16px 0' }}>
            <NotesTab incidentId={incidentId} />
          </div>
        </TabPane>
        
        <TabPane 
          tab={
            <Tooltip title="Crisis Files: Upload, manage and access documents, images, PDFs and other files related to the incident. Organize supporting materials and evidence.">
              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span>📎</span>
                <span>Crisis Files</span>
              </span>
            </Tooltip>
          } 
          key="files"
        >
          <div style={{ padding: '16px 0' }}>
            <LinkedDocsTab incidentId={incidentId} />
          </div>
        </TabPane>
      </Tabs>
      
      <style jsx>{`
        .documentation-sub-tabs .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
          background: #ffffff;
          border: 1px solid #d9d9d9;
          border-bottom: none;
          border-radius: 6px 6px 0 0;
          margin-right: 4px;
          transition: all 0.3s ease;
        }
        
        .documentation-sub-tabs .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab:hover {
          color: #39325b;
          border-color: #39325b;
        }
        
        .documentation-sub-tabs .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active {
          color: #39325b;
          background: #ffffff;
          border-color: #39325b;
          border-bottom-color: #ffffff;
        }
        
        .documentation-sub-tabs .ant-tabs-card > .ant-tabs-nav::before {
          border-bottom: 1px solid #f0f0f0;
        }
        
        .documentation-sub-tabs .ant-tabs-card > .ant-tabs-content-holder {
          background: #ffffff;
          border: 1px solid #f0f0f0;
          border-top: none;
          border-radius: 0 0 6px 6px;
        }
        
        .documentation-sub-tabs .ant-tabs-card > .ant-tabs-content-holder > .ant-tabs-content {
          padding: 0;
        }
      `}</style>
    </div>
  );
};

export default IncidentDocumentationTab; 